import { useEffect } from "react"

import AllChildrenMailbox from "./AllChildrenMailbox"
import ChildMailbox from "./ChildMailbox"
import useMailboxStore from "./hooks/useMailboxStore"
import MailboxModal from "./MailboxModal"
import SendMailButton from "./SendMailButton"
import useMobile from "../../../../hooks/useMobile"
import { useFamilyQuery } from "../../../../networking/queries"
import { FamilyQuerySelect } from "../../../../types"

const MailboxTab = () => {
  const isMobile = useMobile()
  const { data: children } = useFamilyQuery(FamilyQuerySelect.CHILDREN)
  const { selectedUserId, setSelectedUserId } = useMailboxStore()
  // If only one child, show the child's mail
  useEffect(() => {
    if (!children) return
    if (children.length === 1) {
      setSelectedUserId(children[0].user.id)
    }
  }, [children, setSelectedUserId])

  if (!children) return <></>

  return (
    <div className="mt-4">
      {selectedUserId && children.length === 1 ? (
        <ChildMailbox />
      ) : (
        <AllChildrenMailbox />
      )}
      <MailboxModal />

      <div
        className={`fixed right-0 mr-4 ${
          isMobile ? "bottom-[82px]" : "bottom-[40px]"
        }`}
      >
        <SendMailButton />
      </div>
    </div>
  )
}

export default MailboxTab
